import React from 'react';
import { FormInputContainerComponent, ItemComponent } from './InputWrappersComponent';

export class LegendFieldComponent extends React.Component {
    // RGAA : les legends d'erreur (color-err) et de succès (success) apparaissent
    // dynamiquement après soumission ; le role alert/status les fait restituer par
    // les lecteurs d'écran à leur apparition. La classe est la convention du projet.
    getRole = className => {
        if (className.includes('color-err')) {
            return 'alert';
        }
        if (className.includes('success')) {
            return 'status';
        }
        return undefined;
    };

    render() {
        const { children, classNameInputContainer } = this.props;
        const className = classNameInputContainer ? classNameInputContainer : '';

        return (
            <FormInputContainerComponent
                role={this.getRole(className)}
                className={`form-input-legend ${className}`}>
                <ItemComponent className="item item-legend">{children}</ItemComponent>
            </FormInputContainerComponent>
        );
    }
}

export default LegendFieldComponent;



// WEBPACK FOOTER //
// ./src/components/form/LegendFieldComponent.js